<div class="fluid-container bg-light">
    <div
        class="fluid-container hero-image-small"
        [ngStyle]="jumbotronStyles$ | async"
    >
        <div class="container d-sm-flex d-none">
            <div class="black-trans-bg p-3 mt-4 mt-lg-3">
                <h1 class="m-0 text-white">{{ infotextHeader | async }}</h1>
            </div>
        </div>
    </div>

    <div class="container py-5">
        <div class="row">
            <div class="col-md-8">
                <div class="card shadow border-0 h-100">
                    <div class="card-body">
                        <h1 class="mb-5 d-block d-sm-none">
                            {{ infotextHeader | async }}
                        </h1>

                        <div *ngFor="let item of infoItems">
                            <ng-container
                                *ngIf="
                                    contentHelperService.getFullKeyNameIfExists(
                                        'info-item-' + item.id + '-text'
                                    ) | async as cmsKey
                                "
                            >
                                <div
                                    *ngIf="
                                        item.useCmsForContent === true &&
                                        activeId === item.id
                                    "
                                    containsyoutube
                                    [innerHtml]="
                                        cmsKey
                                            | cmsText
                                                : [{ community: communityCode }]
                                            | async
                                    "
                                    routeTransformer
                                ></div>
                            </ng-container>
                        </div>

                        <div *ngIf="activeItem">
                            <div
                                *ngFor="
                                    let subItem of activeItem.subItems;
                                    let itemIndex = index
                                "
                            >
                                <div
                                    class="col-12 mx-auto"
                                    *ngIf="
                                        contentHelperService.getFullKeyNameIfExists(
                                            'info-item-' +
                                                activeItem.id +
                                                '-' +
                                                (itemIndex + 1)
                                        ) | async as cmsKey
                                    "
                                >
                                    <div class="row mb-3 border rounded p-3">
                                        <div
                                            class="col-lg-2 col-md-4 col-6 mx-auto d-block"
                                        >
                                            <img
                                                class="img-fluid"
                                                [attr.src]="
                                                    'info-item-' +
                                                        activeItem.id +
                                                        '-bullet-' +
                                                        (itemIndex + 1) +
                                                        '-img'
                                                        | cmsImageSrc
                                                        | async
                                                "
                                                [attr.alt]="
                                                    'info-item-' +
                                                        activeItem.id +
                                                        '-bullet-' +
                                                        (itemIndex + 1) +
                                                        '-img'
                                                        | cmsImageAlt
                                                        | async
                                                "
                                                height="100"
                                                alt=""
                                            />
                                        </div>
                                        <div
                                            class="col-lg-10 col-md-8 col-12"
                                            [innerHTML]="
                                                cmsKey | cmsText | async
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-md-0 mt-3">
                <div class="d-grid">
                    <button
                        class="btn btn-primary btn-lg text-uppercase btn-responsive"
                        *ngIf="this.registrationEnabled$ | async"
                        [routerLink]="'../../register'"
                        id="homeRegisterBtnAlternative"
                        gaEvent
                        [gaPage]="{ path: communityCode + '/info' }"
                        [gaActivity]="{
                            category: 'register-button',
                            action: 'click',
                        }"
                    >
                        <span
                            [innerHTML]="
                                'register-' +
                                    (phaseService.getCmsAppendString$ | async) +
                                    'button-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></span>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>

                <div class="card mt-3">
                    <h5 class="card-header">
                        {{ 'info-more-information-header' | cmsText | async }}
                    </h5>
                    <ul class="list-group list-group-flush">
                        <a
                            [routerLink]="'../' + item.id"
                            *ngFor="let item of infoItems"
                            [routerLinkActive]="['active']"
                            class="list-group-item list-group-item-action"
                        >
                            {{
                                'info-item-' + item.id + '-header'
                                    | cmsText
                                    | async
                            }}
                        </a>
                    </ul>
                </div>

                <app-contact-options
                    [communityCode]="communityCode"
                    [contactPhoneCmsKey]="'contact-phone-number'"
                    [contactPhone2CmsKey]="'sidebar-phone-2'"
                    [showFaqLink]="true"
                    class="d-flex my-3"
                >
                </app-contact-options>
            </div>
        </div>
    </div>
</div>
<section
    class="fluid-container mt-5 py-5 bg-light"
    *ngIf="this.registrationEnabled$ | async"
>
    <div class="container text-primary text-center">
        <h2
            class="mb-4"
            [innerHTML]="
                'info-register-' +
                    (phaseService.getCmsAppendString$ | async) +
                    'header'
                    | cmsText
                    | jpText
                    | async
            "
        ></h2>
        <div class="d-grid">
            <button
                class="btn btn-primary btn-lg text-uppercase px-5"
                [routerLink]="'../../register'"
                id="homeRegisterBtn"
                gaEvent
                [gaPage]="{ path: communityCode + '/info' }"
                [gaActivity]="{ category: 'register-button', action: 'click' }"
            >
                <span
                    [innerHTML]="
                        'register-' +
                            (phaseService.getCmsAppendString$ | async) +
                            'button-text'
                            | cmsText
                            | jpText
                            | async
                    "
                ></span>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
    </div>
</section>
